import { useEffect, useRef, useState } from 'react';

/**
 * The live-reveal hero number (e.g. the Databricks row count jumping 2,222 → 3,333): counts up from
 * zero with an ease-out sweep, then settles with a small pop. Re-animates when the value changes.
 */
export function CountFlip({ value, label }: { value: number; label: string }) {
  const [shown, setShown] = useState(0);
  const [settled, setSettled] = useState(false);
  const raf = useRef(0);

  useEffect(() => {
    setSettled(false);
    const start = performance.now();
    const DUR = 1100;
    const tick = (now: number) => {
      const t = Math.min((now - start) / DUR, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setShown(Math.round(value * eased));
      if (t < 1) raf.current = requestAnimationFrame(tick);
      else setSettled(true);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [value]);

  return (
    <div className="dp-count" aria-live="polite">
      <span className={`dp-count-num ${settled ? 'settled' : ''}`}>{shown.toLocaleString('en-GB')}</span>
      <span className="dp-count-label">{label}</span>
    </div>
  );
}
